import React from 'react';
import { HalfScreenHero, type HalfScreenHeroProps } from '../../HalfScreenHero';
import {
  useUrlFromVideoBreakpoints,
  type VideoBreakpointProps,
} from '../utils';

export type VideoHalfScreenHeroProps = VideoBreakpointProps &
  Omit<HalfScreenHeroProps, 'media'>;

export const VideoHalfScreenHero = ({
  mobileVideo,
  tabletVideo,
  videoDescription,
  desktopVideo,
  ctaCopy,
  ctaHref,
  CtaButton,
  description,
  eyebrow,
  title,
  variant,
  soundControls,
  captions,
  signInUrl,
  contentOrder,
  playPauseButtonSize,
}: VideoHalfScreenHeroProps) => {
  const videoUrl = useUrlFromVideoBreakpoints({
    url: {
      mobile: mobileVideo,
      tablet: tabletVideo,
      desktop: desktopVideo,
    },
  });

  return (
    <HalfScreenHero
      media={{
        type: 'video',
        videoUrl,
        videoDescription,
        captions,
        soundControls,
        playPauseButtonSize,
      }}
      description={description}
      eyebrow={eyebrow}
      title={title}
      variant={variant}
      signInUrl={signInUrl}
      contentOrder={contentOrder}
      {...(CtaButton ? { CtaButton } : { ctaCopy, ctaHref })}
    />
  );
};
